import React from "react";
import i18n from '../../locales/i18n';
import { email_widget_wrapper_style } from './emailWidgetPreviewStyle';
import EmailLayout from '../EmailLayout';
import EmailLayoutWidget from './EmailLayoutWidget';
import qrPreview from '../../assets/images/qrPreview.svg';

/** Display size matches Engine Tickets.qrcode at dotSize 6 (198px). */
const QR_PX = 198;

/** Entry QR of the single ticket in the email context. */
class EntryQrWidget extends EmailLayoutWidget {

    constructor(properties) {
        super({
            ...(EntryQrWidget.getDefaultOptions()),
            ...properties,
            type: EmailLayout.IMAGE,
            subType: EmailLayout.ENTRY_QRCODE,
        });
    }

    static getDefaultOptions() {
        return {
            options: {
                style: {
                    align: 'center',
                    objectFit: "contain",
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    backgroundColor: '#FFFFFF',
                    padding: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10,
                    }
                },
            }
        };
    }

    getHandledOptions() {
        return super.getHandledOptions().concat([
            EmailLayout.OPTION_ALIGNMENT,
            EmailLayout.OPTION_PADDING,
        ]);
    }

    getPreview(props) {
        const style = this.options?.style || {};

        return (
            <div style={{
                ...email_widget_wrapper_style(style),
                textAlign: style.align || 'center',
                backgroundColor: style.backgroundColor || '#ffffff',
                height: 'auto',
            }}>
                <img
                    ref={props.ref}
                    src={qrPreview}
                    width={QR_PX}
                    height={QR_PX}
                    alt={i18n.t('layouts.alt_entry_qrcode')}
                    style={{
                        display: 'block',
                        width: QR_PX,
                        height: QR_PX,
                        margin: '0 auto',
                        backgroundColor: '#ffffff',
                    }}
                />
            </div>
        );
    }

    getIcon() {
        return 'qrcode';
    }
}

export default EntryQrWidget;
